import { Base } from "../base";
export var JobName;
(function (JobName) {
    JobName["AIRDROP_NFT"] = "airdrop_nft";
})(JobName || (JobName = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["CREATED"] = "created";
    JobStatus["PENDING"] = "pending";
    JobStatus["IN_PROGRESS"] = "in_progress";
    JobStatus["COMPLETED"] = "completed";
    JobStatus["FAILED"] = "failed";
})(JobStatus || (JobStatus = {}));
export class JobBase extends Base {
    constructor(params) {
        super(params);
        this.name = params.name;
        this.refIds = params.refIds || [];
        this.status = params.status || JobStatus.CREATED;
        if (params.data)
            this.data = params.data;
        if (params.result)
            this.result = params.result;
        if (params.error)
            this.error = params.error;
    }
}
